import { render } from "./ForwardModal.vue?vue&type=template&id=a6f14938"
import script from "./ForwardModal.vue?vue&type=script&lang=ts"
export * from "./ForwardModal.vue?vue&type=script&lang=ts"
script.render = render

export default script